<template>
	<section class="ip-list-panel">
		<div class="panel-heading">
			<div>
				<h3>访问记录</h3>
				<p>共 {{ total }} 条记录，可按 IP 和访问时间筛选。</p>
			</div>
			<el-tag type="info" effect="plain">实时数据</el-tag>
		</div>
		<div class="filter-bar">
			<el-select v-model="listQuery.domain_group_id" clearable filterable placeholder="全部分组" @change="handleFilter">
				<el-option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id" />
			</el-select>
			<el-input v-model.trim="listQuery.ip" clearable placeholder="输入完整 IP 地址" prefix-icon="el-icon-search" @keyup.enter.native="handleFilter" />
			<el-date-picker v-model="dateTime" type="datetimerange" value-format="timestamp" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" @keyup.enter.native="handleFilter" />
			<el-button type="primary" icon="el-icon-search" @click="handleFilter">查询</el-button>
			<el-button icon="el-icon-refresh" @click="resetFilter">重置</el-button>
		</div>

		<el-table v-loading="listLoading" :data="list" class="ip-table" :height="height" empty-text="暂无访问记录" row-key="id">
			<el-table-column label="IP 地址" min-width="185">
				<template slot-scope="{ row }"
					><el-button type="text" icon="el-icon-document-copy" @click="copyLine(row.ip)">{{ row.ip }}</el-button></template
				>
			</el-table-column>
			<el-table-column label="归属地" prop="ip_addr" min-width="160" show-overflow-tooltip />
			<el-table-column label="所属分组" min-width="150">
				<template slot-scope="{ row }"
					><el-tag size="mini" effect="plain">{{ groupName(row.domain_group_id) }}</el-tag></template
				>
			</el-table-column>
			<el-table-column label="访问链路" prop="access_path" width="300" show-overflow-tooltip>
				<template slot-scope="{ row }">{{ row.access_path || '旧记录暂无链路' }}</template>
			</el-table-column>
			<el-table-column label="访问时间" prop="ctime" min-width="170" />
			<el-table-column label="状态" width="108">
				<template slot-scope="{ row }"
					><el-tag :type="row.state | statusFilter" effect="light">{{ row.state | stateTxt }}</el-tag></template
				>
			</el-table-column>
			<el-table-column label="操作" width="100" align="right">
				<template slot-scope="{ row }"><el-button v-if="row.state !== 2" type="text" class="danger-action" @click="handleBlacklist(row)">加入黑名单</el-button><span v-else class="muted">已拦截</span></template>
			</el-table-column>
		</el-table>
		<pagination v-if="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.pagesize" @pagination="getList" />
	</section>
</template>

<script>
	export default {
		name: 'IPsList',
		filters: {
			statusFilter(status) {
				return status === 2 ? 'danger' : 'success';
			},
			stateTxt(status) {
				return status === 2 ? '已拉黑' : '正常';
			}
		},
		data() {
			return { list: [], groups: [], listLoading: true, listQuery: { page: 1, pagesize: 20, ip: '', domain_group_id: '' }, total: 0, dateTime: '' };
		},
		computed: {
			height() {
				return this.$baseTableHeight();
			}
		},
		created() {
			this.loadGroups();
			this.getList();
		},
		methods: {
			handleFilter() {
				this.listQuery.page = 1;
				if (this.dateTime) {
					this.listQuery.ctime = Math.round(this.dateTime[0] / 1000);
					this.listQuery.etime = Math.round(this.dateTime[1] / 1000);
				} else {
					delete this.listQuery.ctime;
					delete this.listQuery.etime;
				}
				this.getList();
			},
			resetFilter() {
				this.listQuery.ip = '';
				this.listQuery.domain_group_id = '';
				this.dateTime = '';
				this.handleFilter();
			},
			loadGroups() {
				this.request.get('/domain-group', { params: { state: 2 } }).then((data) => {
					this.groups = data.list || [];
				});
			},
			groupName(id) {
				if (!id) return '暂无分组';
				const group = this.groups.find((item) => String(item.id) === String(id));
				return group ? group.name : '暂无分组';
			},
			getList() {
				this.listLoading = true;
				this.request
					.get('/ip-list', { params: this.listQuery })
					.then((ret) => {
						this.list = ret.list || [];
						this.total = ret.count || 0;
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			copyLine(ip) {
				this.$copyText(ip).then(
					() => this.$message.success('IP 已复制'),
					() => this.$message.error('复制失败')
				);
			},
			handleBlacklist(row) {
				this.$baseConfirm(`确定将 ${row.ip} 加入黑名单吗？`, '风险操作', () => {
					this.request.post('/ipblack-add', { id: row.id }).then(() => {
						this.$message.success('已加入黑名单');
						this.getList();
					});
				});
			}
		}
	};
</script>

<style scoped>
	.panel-heading {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;
	}
	.panel-heading h3 {
		margin: 0;
		color: #24324a;
		font-size: 18px;
	}
	.panel-heading p {
		margin: 7px 0 0;
		color: #8491a8;
		font-size: 13px;
	}
	.filter-bar {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		margin-bottom: 18px;
		padding: 14px;
		border-radius: 8px;
		background: #f7f9fc;
	}
	.filter-bar .el-input {
		width: 220px;
	}
	.filter-bar .el-select {
		width: 180px;
	}
	.ip-table {
		border: 1px solid #edf0f5;
		border-radius: 8px;
		overflow: hidden;
	}
	.danger-action {
		color: #e05252;
	}
	.muted {
		color: #a6afbd;
		font-size: 13px;
	}
	@media (max-width: 640px) {
		.filter-bar .el-input,
		.filter-bar .el-select,
		.filter-bar .el-date-editor {
			width: 100%;
		}
	}
</style>
